import { HttpClient } from '@aurelia/fetch-client';
import { DI } from 'aurelia';
import { ITokenService } from '../services/token-service';

export const IHttpConfig = DI.createInterface<IHttpConfig>('IHttpConfig', (x) =>
    x.singleton(HttpConfig)
);
export interface IHttpConfig extends HttpConfig {}

export class HttpConfig {
    private http;

    constructor(@ITokenService readonly tokenService: ITokenService) {}

    configure(http: HttpClient) {
        const tokenService = this.tokenService;
        this.http = http.configure((config) => {
            config.useStandardConfiguration();
            config.withDefaults({
                headers: {
                    Accept: 'application/json',
                    'content-type': 'application/json',
                },
            });
            config.withInterceptor({
                async request(request) {
                    request.headers.append(
                        'Authorization',
                        'Bearer ' + tokenService.getAuthToken()
                    );
                    return request;
                },
                async response(response) {
                    return response;
                },
            });

            return config;
        });

        return this.http;
    }
}
